<div class="layout-footer text-xs dh-muted" style="gap:8px">
    <img src="assets/logo.webp" height="28" alt="Drink Hopping">
    <span>Panel de administración</span>
</div>
